import { sendRequest } from 'best-modules/vue-utils'
import type {
  AuthSessionResponse,
  AuthEmailPayload,
  AuthEmailResponse,
  AuthLoginPayload,
  AuthLoginResponse,
  AuthSetupPayload,
  AuthSetupResponse,
  AuthCodePayload,
  AuthSuccessResponse,
} from '@/types/sso'

const currentSession = (): Promise<AuthSessionResponse> => {
  const url = import.meta.env.VITE_AUTH_SESSION_URL
  if (!url?.trim()) {
    return Promise.reject(new Error('VITE_AUTH_SESSION_URL is not configured'))
  }
  return sendRequest({
    name: 'currentSession',
    method: 'get',
    url,
  })
}

const checkEmail = (payload: AuthEmailPayload): Promise<AuthEmailResponse> => {
  const url = import.meta.env.VITE_AUTH_EMAIL_URL
  if (!url?.trim()) {
    return Promise.reject(new Error('VITE_AUTH_EMAIL_URL is not configured'))
  }
  return sendRequest({
    name: 'checkEmail',
    method: 'post',
    url,
    payload,
  })
}

const passwordLogin = (
  payload: AuthLoginPayload
): Promise<AuthLoginResponse> => {
  const url = import.meta.env.VITE_AUTH_LOGIN_URL
  if (!url?.trim()) {
    return Promise.reject(new Error('VITE_AUTH_LOGIN_URL is not configured'))
  }
  return sendRequest({
    name: 'passwordLogin',
    method: 'post',
    url,
    payload,
  })
}

const setupAuthenticator = (
  payload: AuthSetupPayload
): Promise<AuthSetupResponse> => {
  const url = import.meta.env.VITE_AUTH_SETUP_URL
  if (!url?.trim()) {
    return Promise.reject(new Error('VITE_AUTH_SETUP_URL is not configured'))
  }
  return sendRequest({
    name: 'setupAuthenticator',
    method: 'post',
    url,
    payload,
  })
}

const confirmAuthenticator = (
  payload: AuthCodePayload
): Promise<AuthSuccessResponse> => {
  const url = import.meta.env.VITE_AUTH_CONFIRM_SETUP_URL
  if (!url?.trim()) {
    return Promise.reject(
      new Error('VITE_AUTH_CONFIRM_SETUP_URL is not configured')
    )
  }
  return sendRequest({
    name: 'confirmAuthenticator',
    method: 'post',
    url,
    payload,
  })
}

const verifyAuthenticator = (
  payload: AuthCodePayload
): Promise<AuthSuccessResponse> => {
  const url = import.meta.env.VITE_AUTH_VERIFY_CODE_URL
  if (!url?.trim()) {
    return Promise.reject(
      new Error('VITE_AUTH_VERIFY_CODE_URL is not configured')
    )
  }
  return sendRequest({
    name: 'verifyAuthenticator',
    method: 'post',
    url,
    payload,
  })
}

export {
  currentSession,
  checkEmail,
  passwordLogin,
  setupAuthenticator,
  confirmAuthenticator,
  verifyAuthenticator,
}
